module.exports = __webpack_public_path__ + "static/4iiii2-924032581e55594b3d9fd663126c7881.jpg";